import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyData} from './currency-data';

@Pipe({
  name: 'appCurrency',
})
export class AppCurrencyPipe implements PipeTransform {
  transform(
    value: number | string,
    currencyData: CurrencyData,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  ): string {
    if (!currencyData?.locale || !currencyData?.currencyCode) return '';

    return new Intl.NumberFormat(currencyData.locale, {
      style: 'currency',
      currency: currencyData.currencyCode,
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    }).format(+(value ?? 0));
  }
}
